import React, { useState, useEffect } from "react";
import moment from "moment";
import { View } from "react-native";

import cardStyles from "./cardStyles";
import Goal from "../../resolution/goals/Goal";
import CardUtils from "./CardUtils";
import SnoozeIcon from "../../common/dialog/SnoozeIcon";
import ElementsHelper from '../../elements/ElementsHelper';

export default function GoalPreviewCard({
  controller,
  data,
  isSnoozed = false,
  onSnooze = null,
}) {
  const [showCard, setShowCard] = useState(true);

  const cardUtils = new CardUtils(controller, data, setShowCard);
  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  const goalStart = moment(data.from).format("ddd, MMM DD");

  const element = ElementsHelper.findById(controller, data.gem_target_id);

  const goal = {
    target_name: element?.name,
    target_emoji: element?.icon,
    hours: data.tracked,
    target_hours: data.target,
    time_unit: data.goal_time_unit,
    target_achieved: 0,
    total_pct: Math.max(Math.min(Math.abs(data.total_pct), 1), 0),
    achieved_pct: data.target ? data.tracked / data.target : 0,
    mood: data.mood,
    text: `Goal starts ${goalStart}!`,
    from: data.from,
    to: data.to
  };

  return !isSnoozed && !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { minHeight: 86 }]}>
        <SnoozeIcon
          onPress={(e) => onSnooze(cardUtils, e)}
          style={cardStyles.closeButton}
        />

        <View style={{ width: "100%" }}>
          <Goal
            style={cardStyles.goal}
            controller={controller}
            goal={goal}
            allowEdit={false}
          />
        </View>
      </View>
    </View>
  );
}
